import { createReducer, on } from "@ngrx/store";
import { Announcement } from "../../../shared/models/announcement.model";
import * as AnnouncementActions from './announcement.actions';

export interface AnnouncementState {
  pending: Announcement | null;
  all: Announcement[];
  loading: boolean;
  error: any;
  searchTerm: string;
  filters: AnnouncementFilter;
}

export interface AnnouncementFilter {
  is_global?: boolean | null;
}

export const initialState: AnnouncementState = {
  pending: null,
  all: [],
  loading: false,
  error: null,
  searchTerm: '',
  filters: {}
};

export const announcementReducer = createReducer(
  initialState,

  on(AnnouncementActions.loadPendingAnnouncement, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(AnnouncementActions.loadPendingAnnouncementSuccess, (state, { announcement }) => ({
    ...state,
    pending: announcement,
    loading: false
  })),
  on(AnnouncementActions.loadPendingAnnouncementFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  on(AnnouncementActions.acknowledgeAnnouncementSuccess, (state) => ({
    ...state,
    pending: null
  })),
  on(AnnouncementActions.acknowledgeAnnouncementFailure, (state, { error }) => ({
    ...state,
    error
  })),

  on(AnnouncementActions.loadAnnouncements, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(AnnouncementActions.loadAnnouncementsSuccess, (state, { announcements }) => ({
    ...state,
    loading: false,
    all: announcements
  })),

  on(AnnouncementActions.createAnnouncementSuccess, (state, { announcement }) => ({
    ...state,
    all: [announcement, ...state.all]
  })),

  on(AnnouncementActions.deleteAnnouncementSuccess, (state, { id }) => ({
    ...state,
    all: state.all.filter(a => a.id !== id)
  })),
  on(AnnouncementActions.createAnnouncementFailure, (state, { error }) => ({
    ...state,
    error
    })),

    on(AnnouncementActions.deleteAnnouncementFailure, (state, { error }) => ({
    ...state,
    error
    })),

    on(AnnouncementActions.loadAnnouncementsFailure, (state, { error }) => ({
    ...state,
    error
    })),
    on(AnnouncementActions.updateAnnouncementSearchTerm, (state, { term }) => ({
        ...state,
        searchTerm: term
    })),

    on(AnnouncementActions.resetAnnouncementSearchTerm, (state) => ({
        ...state,
        searchTerm: ''
    })),
    on(AnnouncementActions.updateAnnouncementFilters, (state, { filters }) => ({
        ...state,
        filters: { ...state.filters, ...filters }
    })),

    on(AnnouncementActions.clearAnnouncementFilters, (state) => ({
        ...state,
        filters: {}
    })),
    on(AnnouncementActions.resetAnnouncements, () => initialState)

);
